import { imageMediaViewPorts } from '@/constants/image';
import { dataTestTransformer } from '@/utils/data-test-helper';
import { PromoContent } from '@cinemark/content-api-client';
import { clsx } from 'clsx';
import { CinemarkLink } from '../../cinemark-link/cinemark-link';

type PromotionalImageProps = {
  className?: string;
  dataLinkCategory: string;
  dataLinkName?: string;
  promoContent: PromoContent;
};

export const PromotionalImage = ({ className, dataLinkCategory, dataLinkName, promoContent }: PromotionalImageProps): React.JSX.Element | null => {
  if (!promoContent) {
    return null;
  }

  const image =
    <picture>
      <source media={imageMediaViewPorts.minLarge}
        srcSet={promoContent.largeImage?.url || ''}
      />
      <source media={imageMediaViewPorts.minMedium}
        srcSet={promoContent.mediumImage?.url || ''}
      />
      <img alt={promoContent.altText || `${promoContent.promoTitle || promoContent.title} Image`}
        className={clsx('rounded-md w-full object-cover', className)}
        srcSet={promoContent.smallImage?.url || ''}
      />
    </picture>
  ;

  if (promoContent.url) {
    return (
      <CinemarkLink dataLinkCategory={dataLinkCategory}
        dataLinkName={dataLinkName || `Promo Image - ${promoContent.promoTitle || promoContent.title}`}
        dataTest={`link-${dataTestTransformer(promoContent.promoTitle || promoContent.title || 'promo-image')}`}
        href={promoContent.url}
      >
        {image}
      </CinemarkLink>
    );
  }

  return image;
};
